import { Goal, GoalType } from 'shared/types/goal';
import { LifeArea } from 'shared/types/life-area';

export enum GoalTreeItemIds {
  Goal = 'goal',
  LifeArea = 'life-area',
  NoLifeArea = 'no-life-area',
}

export enum GoalTreeCreateOption {
  LifeArea = 'life-area',
  Goal = 'goal',
  Project = 'project',
}

export type GoalTreeItemBase = {
  indentationLevel: number;
  displayColor?: string | null;
  parentName?: string;
  hasChildren?: boolean;
};

export type GoalItem = {
  type: GoalTreeItemIds.Goal;
  goalType?: GoalType | null;
} & GoalTreeItemBase &
  Omit<Goal, 'type'>;

export type LifeAreaItem = {
  type: GoalTreeItemIds.LifeArea;
} & GoalTreeItemBase &
  LifeArea;

export type NoLifeAreaItem = {
  type: GoalTreeItemIds.NoLifeArea;
  id: GoalTreeItemIds.NoLifeArea;
  name: string;
} & GoalTreeItemBase;

export type GoalTreeItem = GoalItem | LifeAreaItem | NoLifeAreaItem;
